export function countBattleStats(battles, id) {
  let lostBuildings = 0
  let wonBuildings = 0
  let lostBattles = 0
  let wonBattles = 0
  for (let i = 0; i < battles.length; i++) {
    if (battles[i].winnerId == id) {
      wonBattles++
      if (battles[i].createdBy == id) {
        wonBuildings++
      }
    } else {
      lostBattles++
      if (battles[i].createdBy != id) {
        lostBuildings++
      }
    }
  }
  return {
    lostBattles: lostBattles,
    Battles: wonBattles,
    lostBuildings: lostBuildings,
    wonBuildings: wonBuildings,
  }
}
